import { PurchaseOrderDeliveryFormik } from 'types/PurchaseOrderDeliveryFormik';

export const createEmptyPurchaseOrderDeliveryFormik = (): PurchaseOrderDeliveryFormik => ({
  driverFirstName: '',
  driverLastName: '',
  eta: null,
  truckPlate: '',
  orderId: '',
  timeSlot: null,
  logisticsCompany: '',
  contacts: '',
  cmrNumber: '',
  cmrDate: null,
  loadingReference: '',
  warehouseId: ''
});